// Signup is a separate purpose. Only the restricted handle and fixed deadline
// survive reload; current state and retry guidance come from read-only status.
const signupKey = 'ts.signup.v1';
const states = ['pending', 'expired', 'exhausted', 'throttled', 'used', 'cancelled', 'stale', 'password-policy'];
export function createSignupState(storage, now = () => Date.now()) {
    let current = null, completed = false;
    function valid(p) {
        return p && p.Version === 1 && typeof p.Proof === 'string' && p.Proof.startsWith('tsc1.') && p.Proof.length <= 2048 &&
            typeof p.ExpiresUtc === 'string' && Number.isFinite(Date.parse(p.ExpiresUtc)) && Date.parse(p.ExpiresUtc) <= now() + 600000;
    }
    function clear() { current = null; completed = true; storage.removeItem(signupKey); }
    return {
        resume() {
            if (completed) return null;
            if (!current) {
                try {
                    const saved = JSON.parse(storage.getItem(signupKey));
                    if (!valid(saved) || Object.keys(saved).sort().join(',') !== 'ExpiresUtc,Proof,Version') { storage.removeItem(signupKey); return null; }
                    current = { ...saved, State: 'pending', RetryAfterSeconds: 0 };
                } catch { storage.removeItem(signupKey); return null; }
            }
            return { ...current, State: Date.parse(current.ExpiresUtc) <= now() ? 'expired' : current.State };
        },
        accept(p) {
            if (completed || !valid(p) || Object.keys(p).sort().join(',') !== 'ExpiresUtc,Proof,RetryAfterSeconds,State,Version' ||
                !states.includes(p.State) || !Number.isInteger(p.RetryAfterSeconds) || p.RetryAfterSeconds < 0 || p.RetryAfterSeconds > 600 ||
                (current && (p.Proof !== current.Proof || p.ExpiresUtc !== current.ExpiresUtc))) throw new Error('Invalid signup continuation');
            if (current && !['pending', 'throttled'].includes(current.State)) return { ...current };
            current = { Version: 1, Proof: p.Proof, ExpiresUtc: p.ExpiresUtc, RetryAfterSeconds: p.RetryAfterSeconds, State: p.State };
            storage.setItem(signupKey, JSON.stringify({ Version: 1, Proof: p.Proof, ExpiresUtc: p.ExpiresUtc }));
            return this.resume();
        },
        clear,
        begin() { if (completed) { current = null; completed = false; } },
        restart() { clear(); completed = false; },
        active() { const p = this.resume(); return p && ['pending', 'throttled'].includes(p.State); }
    };
}
